import type {ReactElement} from 'react';
import {Icon} from '@Components/icon-v2/icon';
import {IconSize} from '@Components/icon-v2/icon.types';
import {Text, TextSize} from '@Components/text/text';
import type {RightPanelOverlayHeaderProps} from './right-panel-overlay-header.types';
import styles from './right-panel-overlay-header.module.scss';

export function RightPanelOverlayHeader({title, backAriaLabel, onBack}: RightPanelOverlayHeaderProps): ReactElement {
  return (
    <header className={styles.header}>
      <button type="button" className={styles.backButton} aria-label={backAriaLabel} onClick={onBack}>
        <Icon icon="icon-arrow-left" size={IconSize.SIZE_ICON_20} />
      </button>
      <Text val={title} size={TextSize.MD} bold className={styles.title} />
      <span className={styles.spacer} aria-hidden />
    </header>
  );
}
